import React, { FC, CSSProperties } from 'react';
import { Pathname } from 'utils/hooks/navigation/types';
import { MixpanelEvents } from 'integrations/mixpanel/Events/MixpanelEvents';
import { beautifyName } from 'utils/textUtil';
import { useMixpanel } from 'integrations/mixpanel/useMixpanel';
import { AppLinkWithWrapper } from 'common/AppLink/AppLinkWithWrapper';
import { SideNavBarItem, SideBarDivider } from '@utmost.co/utmost-design-system';
import { useSelected } from './useSelected';

interface Props {
  isLastFromGroup: boolean;
  id: string;
  text: string;
  icon: JSX.Element;
  style?: CSSProperties;
}

export const MenuItem: FC<React.PropsWithChildren<Props>> = ({ isLastFromGroup, id, icon, text, style }) => {
  const isSelected = useSelected();
  const { track } = useMixpanel();

  return (
    <>
      <AppLinkWithWrapper
        url={`/${id}` as Pathname}
        hideTextDecoration
        style={style}
        onClick={() => track(MixpanelEvents.general.MAIN_MENU_CLICK, { menuItem: beautifyName(id, '-') })}
        Component={SideNavBarItem}
        componentProps={{
          id,
          icon,
          label: text,
          selected: isSelected(id)
        }}
      />
      {isLastFromGroup && <SideBarDivider />}
    </>
  );
};
